import React from 'react';
import { Dialog } from '@iqueue/iq-ui';

/**
 * Convenience wrapper over the compound iq-ui Dialog
 * (Root → Portal → Backdrop → Popup → Title/Content/Actions).
 * Width follows the library's dialog sizing (a wider size option is filed
 * as a library request — docs/IQ_UI_CHAT_GAPS.md §10).
 */
export default function Modal({ open, onClose, title, children, actions }) {
  return (
    <Dialog.Root open={!!open} onOpenChange={(o) => { if (!o && onClose) onClose(); }}>
      <Dialog.Portal>
        <Dialog.Backdrop />
        <Dialog.Popup>
          {title && <Dialog.Title>{title}</Dialog.Title>}
          <Dialog.Content>{children}</Dialog.Content>
          {actions && <Dialog.Actions>{actions}</Dialog.Actions>}
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
